import React, { useEffect } from 'react'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import { compose } from 'recompose'
import { withHooks } from '../enhancers'
import Tooltip from 'rc-tooltip'

const createSliderWithTooltip = Slider.createSliderWithTooltip
const Range = createSliderWithTooltip(Slider.Range)
const Handle = Slider.Handle

const RenderSliderInput = props => {
  const { input } = props
  return (
    <div style={{ display: 'flex' }}>
      <div>
        <input
          className={
            props.meta.touched && props.meta.error
              ? `form-control width-60 is-invalid`
              : 'form-control width-60'
          }
          type="number"
          value={input.value[0] || 0}
          onChange={e => {
            if (parseInt(e.target.value) <= parseInt(input.value[1])) {
              input.onChange([
                e.target.value ? parseInt(e.target.value) : 0,
                input.value[1] ? parseInt(input.value[1]) : 0,
              ])
            }
          }}
          disabled={props.readOnly}
        />
      </div>
      <div
        style={{ display: 'flex', alignItems: 'center' }}
        className="m-l-20 m-r-20"
      >
        <Range
          min={0}
          max={99}
          tipFormatter={value => `${value}`}
          className="width-300"
          value={input.value || [0, 0]}
          onChange={e => {
            input.onChange(e)
          }}
          onBlur={() => input.onBlur(input.value)}
          disabled={props.readOnly}
        />
      </div>
      <div>
        <input
          className={
            props.meta.touched && props.meta.error
              ? `form-control width-60 is-invalid`
              : 'form-control width-60'
          }
          type="number"
          value={input.value[1] || 0}
          onChange={e => {
            if (
              parseInt(e.target.value) >= parseInt(input.value[0]) ||
              !parseInt(input.value[0])
            ) {
              input.onChange([
                input.value[0] ? parseInt(input.value[0]) : 0,
                e.target.value ? parseInt(e.target.value) : 0,
              ])
            }
          }}
          disabled={props.readOnly}
        />
      </div>
    </div>
  )
}

const enhancer = compose(
  withHooks(props => {
    useEffect(() => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSlider = props => {
      const { value, dragging, index, ...restProps } = props
      return (
        <Tooltip
          prefixCls="rc-slider-tooltip"
          overlay={value}
          visible={dragging}
          placement="top"
          key={index}
        >
          <Handle value={value} {...restProps} />
        </Tooltip>
      )
    }
    return {
      handleSlider,
      // setMax,
      // setMin,
      // min,
      // max,
    }
  })
)

export default enhancer(RenderSliderInput)
